import React, { useState, useEffect, useContext } from 'react';
import StarBackground from "../../components/StarBackground";
import Header from "../../components/Header";
import ExeCore from "../../components/ExeCore";
import Controls from "../../components/Controls";
import Character from "../../components/Character";
import Planet from "../../components/Planet";
import '../../styles/Intro.css';
import config from './syllablesConfig';
import {useNavigate} from "react-router-dom";
import { AppContext } from '../../contexts/AppContext';

export default function SyllablesTutorial() {
    // Mock recorder implementation
    const navigate = useNavigate();
    const [isRecording, setIsRecording] = useState(false);
    const { enableText, enableAudio, setEnableText, setEnableAudio } = useContext(AppContext);

    const startRecording = () => {
        setIsRecording(true);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

    const [message, setMessage] = useState('');
    const [started, setStarted] = useState(false);

    return (
        <div style={{
            height: '100vh',
            overflow: 'hidden',
            position: 'relative'
        }}>
            <Header
                color={config.headerColor}
                enableText={enableText}
                setEnableText={setEnableText}
                enableAudio={enableAudio}
                setEnableAudio={setEnableAudio}
            />
            <StarBackground imagePath={config.planetBackground} />

            {/* Opaque white background wrapper */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                padding: '20px',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
            }}>
                <ExeCore image={config.marsImage} size={config.marsSize}/>
            </div>

            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')} // This prop is not currently used by Controls.js
                onStartRecording={() => {
                    startRecording();
                    if (!started) {
                        setStarted(true);
                        setMessage('Facciamo una prova. Ascoltami cantare...');
                        setTimeout(() => setMessage('Adesso, canta con me: BA BA BU BU'), 15000);
                        setTimeout(() => setMessage('Fantastico! Ascoltami di nuovo...'), 28800);
                        setTimeout(() => setMessage('Dai, canta di nuovo con me: BA BA BU BU'), 42000);
                        setTimeout(() => setMessage('Benissimo! Non è difficile, vero? '), 57000);
                        setTimeout(() => setMessage('Ora premi il tasto verde e cantiamo le canzoncine dei marziani'), 61000);
                        setTimeout(() => setMessage('Così Dudi ci darà i pezzi del razzo'), 67000);
                    }
                }} // Pass the explicit startRecording function
                onStopRecording={stopRecording}   // Pass the explicit stopRecording function
                onValidate={() => {
                    // navigate(`/exercise/syllables/test`);
                    navigate(`/exercise/syllables/main/1`); // Per andare diretto al gioco senza passare dal test
                }}
                context={'provaSRT'} //Sostituire con tutorial
                recording={isRecording} // Pass isRecording for the microphone visual feedback
                disableUpload={true}
            />

            <Character name="Mars" position='left' isActive={true} />
            {enableText && message && (
                <div className="bubble speaker-left" style={{ padding: '25px 35px' }}>
                    {message}
                </div>
            )}
            <Character
                name={config.character}
                position='right'
                isActive={false}
            />


            <Planet image={config.planetImage}/>
        </div>
    );
}
